import { render, staticRenderFns } from "./SettingPlacePoup.vue?vue&type=template&id=18bd4f73&scoped=true&"
import script from "./SettingPlacePoup.vue?vue&type=script&lang=js&"
export * from "./SettingPlacePoup.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlacePoup.vue?vue&type=style&index=0&id=18bd4f73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd4f73",
  null
  
)

export default component.exports